import React, { createContext, useContext } from 'react';
import useSoundNotifications from '../hooks/useSoundNotifications';

export const SoundNotificationsContext = createContext(null);

/**
 * Provider для глобального состояния звуковых уведомлений
 * Гарантирует что существует ТОЛЬКО ОДИН экземпляр хука useSoundNotifications
 */
export function SoundNotificationsProvider({ children }) {
  const soundNotifications = useSoundNotifications();

  return (
    <SoundNotificationsContext.Provider value={soundNotifications}>
      {children}
    </SoundNotificationsContext.Provider>
  );
}

/**
 * Хук для доступа к звуковым уведомлениям
 * Использует общий экземпляр из Context
 */
export function useSoundNotificationsContext() {
  const context = useContext(SoundNotificationsContext);
  if (!context) {
    throw new Error('useSoundNotificationsContext must be used within SoundNotificationsProvider');
  }
  return context;
}

/**
 * Defensive variant — returns null when no provider is mounted instead of throwing.
 * Use in components that can render outside the sound provider tree (tests, isolated mounts).
 */
export function useOptionalSoundNotificationsContext() {
  return useContext(SoundNotificationsContext);
}
